import { render, staticRenderFns } from "./ProgramKeywordList.vue?vue&type=template&id=025b146e&"
import script from "./ProgramKeywordList.vue?vue&type=script&lang=js&"
export * from "./ProgramKeywordList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports